import React from 'react'
import { notifyInfo } from 'utils'
// import { copyToClipboard } from 'pages/clients/utils'
import CopyIcon from 'assets/shared/icons/copy.svg'
import './CopyButton.scss'

type CopyButtonProps = {
  text: string,
  className?: string,
  style?: React.CSSProperties
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, className, style }) => {
  const handleCopyClick = () => {
    // copyToClipboard(text)
    notifyInfo('Copied to Clipboard', { containerId: 'modalToast' })
  }

  return (
    <button
      type="button"
      className={className ? `copy-button ${className}` : 'copy-button'}
      style={style}
      onClick={handleCopyClick}
      data-testid="copy-button"
      title="Copy"
    >
      <img src={CopyIcon} alt="copy" />
    </button>
  )
}

export default CopyButton
